import { Button, showAlert } from '@beehive/components';
import React, { useState } from 'react';
import Template from '../components/Template';
import { NodeEnum, getListPathMenuKey } from 'containers/OutBidding/utils';
import { transformToBlobIds } from '../utils';
import isBlank from 'utils/object';
import _ from 'lodash';
import { outsourceCommonDeleteTemporary } from '@mpc/common/src/services/api';
import { getVendorStorage } from '@mpc/common/src/utils';

/**
 * 评估中（比选评审）
 */
const BidOpenReview = (props: any) => {
  const { detail = {}, editFields = [], getDetail, projectMove, quoteData } = props;
  const [loading, setLoading] = useState(false);

  const { permit_actions = {} } = detail;
  const canMove = permit_actions.can_move;
  const hasSubmitted = !!canMove && !!detail?.bidding_suppliers?.[0].bidding_supplier_quotes?.[0]?.created_at;

  // 兼容适配：详情接口 structured 字段（1 为新结构化报价，0 为旧非结构化报价）
  const isStructured = (detail?.structured ?? 0) === 1;

  const handleSubmit = async (validData: any) => {
    const params = await validData();
    if (params) {
      setLoading(true);
      const { evaluationValues, quoteFormValues } = params ?? {};
      const { tender_plan_attach_blob_ids } = evaluationValues ?? {};
      const { bidding_suppliers = [] } = detail;
      const [currentSupplier] = bidding_suppliers;
      const { bidding_supplier_quotes = [] } = currentSupplier;
      const [currentQuote = {}] = bidding_supplier_quotes;

      // structured=1：对齐后端 AwaitingSubmissionBidsMoveBiddingDto 结构（含 bidding_supplier, tabs）
      // structured=0：对齐历史接口，仅传报价核心字段
      const data = isStructured
        ? {
            bidding_supplier_id: detail.current_bidding_supplier_id,
            tender_plan_attach_blob_ids: transformToBlobIds(tender_plan_attach_blob_ids),
            quote_price_attach_blob_ids: transformToBlobIds(quoteFormValues?.bid_attachs),
            quote_price: quoteFormValues?.total_quoted?.value,
            quote_currency: quoteFormValues?.total_quoted?.currency,
            bidding_supplier: {
              bank_account: quoteFormValues?.channel_supplier_bank_dto?.bank_account,
              bank_account_name: quoteFormValues?.channel_supplier_bank_dto?.bank_account_name,
              bank_business_code: quoteFormValues?.channel_supplier_bank_dto?.bank_business_code,
              invoice_belong_area: quoteFormValues?.invoice_belong_area,
              is_oversea_invoice: !!quoteFormValues?.is_oversea_invoice,
              invoice_type: quoteFormValues?.invoice_type,
            },
            quote_detail: {
              tabs: quoteFormValues?.quote_detail,
            },
          }
        : {
            bidding_supplier_id: detail.current_bidding_supplier_id,
            quote_price_attach_blob_ids: transformToBlobIds(evaluationValues?.quote_price_attach_blob_ids),
            quote_price: evaluationValues?.quote_price,
            quote_currency: evaluationValues?.quote_currency,
          };
      try {
        await projectMove(
          {
            id: detail.id,
            pass: true,
            form: {
              ...data,
            },
            state: NodeEnum.BID_OPEN_REVIEW,
            bidding_action: 'SUBMIT',
          },
          {
            menuKey: getListPathMenuKey(),
          },
        );
        showAlert({ type: 'success', message: '提交成功' });

        // 删除服务端暂存数据（仅结构化报价场景，不阻塞主流程）
        if (isStructured) {
          try {
            const { vendorId, tenantCode } = getVendorStorage();
            const code = `${vendorId}_${tenantCode}_${detail.id}`;
            await outsourceCommonDeleteTemporary({
              type: 'outsource_bidding_quote',
              code,
            });
          } catch (e) {
            console.warn('删除暂存数据失败', e);
          }
        }

        getDetail();
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Template
      detail={detail}
      editFields={editFields}
      hasSubmitted={hasSubmitted}
      quoteData={quoteData}
      canEditQuote={canMove}
      renderOpers={(validData: any) => {
        return (
          <>
            {canMove ? (
              <Button onClick={() => handleSubmit(validData)} type="primary" loading={loading} disabled={loading}>
                提交
              </Button>
            ) : null}
          </>
        );
      }}
    />
  );
};

export default BidOpenReview;
